export enum MetricTypesEnum {
  BASE = 'App\\Modules\\Metrics\\MetricTypes\\BaseMetric',
  NETWORK = 'App\\Modules\\Metrics\\MetricTypes\\NetworkMetric',
}
